module.exports = __webpack_public_path__ + "img/DE01121.0c588287.png";